import {MathJax, MathJaxContext} from "better-react-mathjax";
import {isNullOrUndefined} from "../../../services/Validator";

export default function LevelAExampleQuestionText({question}) {
    // Used in LevelAExampleQuestion to display question
    // text in LateX

    // BUILD
    if (isNullOrUndefined(question))
        return null
    return (
        <div className={"w-full text-center px-[12px] mt-[12px]"}>
            <MathJaxContext>
                <MathJax inline dynamic>
                        <span className="whitespace-pre-line font-bold text-[18px] text-white">
                            {question}
                        </span>
                </MathJax>
            </MathJaxContext>
        </div>
    );
}